module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/bride-groom-alt-986bb2fe90aa133d9fe4ee6fdf66b580.svg";